import React from "react";
import logo from "../../assets/images/Logo.png";
import "../../assets/css/DischargeSummary.css";

const DischargeSummary = () => {
  return (
    <div className="discharge-wrapper">
      <div className="hospital-header">
        <div className="hospital-info">
          <p>
            <strong>4Health Homeopathy</strong>
          </p>
          <p>Ground Floor, Sixer Complex, Saradha College Road,</p>
          {/* <p>(Near Bharath Petrol Bunk),</p> */}
          <p>Salem - 636007.</p>
          {/* <p>Plot No: 1, Swaminarayan Nagar,</p>
          <p>New Adgaon Naka, Panchavati,</p>
          <p>Near Lunge Mangal Karyalay,</p>
          <p>Nashik, Maharashtra – 422003</p> */}
          <p>Ph: +91 99448 44408</p>
        </div>
        <div className="hospital-logo">
          <img src={logo} alt="4Health Homeopathy" />
        </div>
      </div>

      <h2 className="discharge-title">Discharge Summary</h2>

      <h3 className="dept">
        Dept of <span>ENT</span>
      </h3>

      <div className="patient-section">
        <div className="patient-table">
          <p>
            <strong>UHID:</strong> APC200002356545
          </p>
          <p>
            <strong>Patient Identifier:</strong> APC2LP56985
          </p>
          <p>
            <strong>Sex:</strong> Male
          </p>
          <p>
            <strong>Date of Discharge:</strong> 02<sup>nd</sup> February 2024
          </p>
          <p>
            <strong>Ward/Bed No:</strong> Third Floor General, Ward Bed No FGW
            14
          </p>
          <p>
            <strong>Surgeons:</strong> Dr. ENT Team, ENT.
          </p>
        </div>
        <div className="patient-table">
          <p>
            <strong>Name:</strong> Mr. Keerthi Ajay Kumar
          </p>
          <p>
            <strong>Age:</strong> 34Yr 11Mth 2Days
          </p>
          <p>
            <strong>Date of Admission:</strong> 01<sup>st</sup> February 2024
          </p>
          <p>
            <strong>Address:</strong> H.No: 7-1-163, Maruthi Veedhi, Chapal bai,
            Secunderabad – 500003
          </p>
          <p>
            <strong>Primary Consultant:</strong> Dr. Niraj Patil and ENT Team
          </p>
        </div>
      </div>

      <div className="diagnosis-section">
        <h4>Diagnosis</h4>
        <p>
          1) Throat and tongue such as UPPP, Transpalatal Advancement
          Pharyngoplasty, TORS, hypoglossal nerve stimulation, tongue reduction,
          and partial epiglottidectomy.
        </p>
      </div>

      <div className="procedure-section">
        <h4>Surgery/Procedures Done</h4>
        <table>
          <thead>
            <tr>
              <th>Surgery/Procedure Name</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Sleep Apnea Surgery</td>
              <td>
                01<sup>st</sup> February 2023
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="footer">
        <p>
          Regd. Office: 4Health Homeopathy, Ward-D, Block No. 50, Jewel
          One Jewellery Upstairs, opp. New Bus Stand Road, Arthanari Nagar,
          Swarnapuri, Salem, Tamil Nadu : +91-9874563210
        </p>
        <p>Corporate Identity Number (CIN): </p>

        <div className="emergency">
          <strong>EMERGENCY CALL - 1066</strong>
        </div>

        <p className="note">
          “KEEP THE REPORTS CAREFULLY AND BRING THEM ALONG DURING YOUR NEXT
          VISIT TO OUR HOSPITAL”<br></br>
          Developed by Aalan Tech soft
        </p>
      </div>
    </div>
  );
};

export default DischargeSummary;